import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

async function clearLegacyDevelopmentServiceWorkers() {
  if (!import.meta.env.DEV || !('serviceWorker' in navigator)) {
    return false;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  if (registrations.length === 0) {
    return false;
  }

  await Promise.all(registrations.map((registration) => registration.unregister()));

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }

  return navigator.serviceWorker.controller !== null;
}

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <>
      <App />
      <ToastContainer />
    </>,
  );
}

clearLegacyDevelopmentServiceWorkers()
  .then((reloadRequired) => {
    if (reloadRequired) {
      window.location.reload();
      return;
    }

    renderApp();
  })
  .catch((error) => {
    console.error('Unable to clear a legacy development service worker.', error);
    renderApp();
  });
